import styled from 'styled-components';
const AccessibleEventHeading = styled.h4.withConfig({
  displayName: "AccessibleEventHeading",
  componentId: "sc-1o2p8vs-0"
})(["font-family:inherit;font-weight:inherit;margin-bottom:0;margin-top:0;display:block;font-size:inherit;line-height:inherit;text-transform:none;width:100%;"]);
export default AccessibleEventHeading;